import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { SupportTicketStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";
import { RedoListDropdown } from "@redotech/redo-web/arbiter-components/list/redo-list-dropdown";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useStatusSelector } from "../hooks/use-status-selector";
import { StatusBadge } from "./badges/support-ticket-badges";
import { FieldLabel } from "./field-label";

export const StatusSelector = memo(function StatusSelector({
  supportTicketId,
  status,
}: {
  supportTicketId: SupportTicketId;
  status: SupportTicketStatus;
}) {
  const {
    statusListItems,
    dropdownOpen,
    badgeRef,
    setBadgeRef,
    handleBadgeClick,
    handleDropdownOpenChange,
    handleItemSelected,
  } = useStatusSelector({ supportTicketId });

  return (
    <Flex align="center" gap="xs" justify="space-between">
      <FieldLabel>Status</FieldLabel>
      <Flex cursor="pointer" onClick={handleBadgeClick} ref={setBadgeRef}>
        <StatusBadge status={status} />
      </Flex>
      <RedoListDropdown
        dropdownAnchor={badgeRef}
        dropdownOpen={dropdownOpen}
        fitToAnchor={false}
        items={statusListItems}
        itemSelected={({ item }) => handleItemSelected(item.value)}
        selectedItems={`status-${status.toLowerCase()}`}
        selectionVariant="none"
        setDropdownOpen={handleDropdownOpenChange}
        size="xs"
      />
    </Flex>
  );
});
